import { useDeviceStore } from '@/stores';
import { track } from './../sendData';

interface TrackData {
  [key: string]: unknown;
}

// 数据缓存key
const CACHE_KEY = 'cacheTrackData';
// 最大缓存数
const DEFAULT_MAX_NUM = 100;
// 上报间隔
const REPORT_INTERVAL = 2000; // 2秒
// 有效曝光时间
const EXPOSURE_DURATION = 300; // 300毫秒

export default class Exposure {
  constructor(
    maxExposureCount = DEFAULT_MAX_NUM,
    duration = EXPOSURE_DURATION
  ) {
    this.maxExposureCount = maxExposureCount;
    this.duration = duration;
    this.init();
  }

  private exposureData: TrackData[] = [];
  private maxExposureCount = 0;
  private timer = 0;
  private duration = 0;
  private observer: IntersectionObserver | null = null;

  /**
   * 初始化
   */
  init() {
    this.sendExposureData();

    // 实例化监听
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // 出现在视窗中
          if (entry.isIntersecting) {
            // 清除当前定时器
            clearTimeout(Number(entry.target.getAttribute('timer')));
            entry.target.setAttribute('start', Date.now().toString());
            // console.log('enter', entry, entry.target.getAttribute('start'));
            // 获取参数
            const tp = entry.target.getAttribute('track-params') || '';
            const deviceStore = useDeviceStore();
            let params = null;
            try {
              params = JSON.parse(tp);
              params.create_time = Date.now(); // 更新曝光时间
              params.network = deviceStore.network; // 更新网络环境
              params.device_id = deviceStore.deviceId; // 更新设备id
            } catch {
              params = null;
            }
            if (!params) {
              return;
            }
            const timer = setTimeout(() => {
              // console.log('setTimeout');
              // 收集参数统一上报，减少网络请求
              this.exposureData.push(params);

              if (this.exposureData.length >= this.maxExposureCount) {
                this.track();
              } else if (this.exposureData.length > 0) {
                this.storeIntoLocalStorage(JSON.stringify(this.exposureData));
              }
            }, this.duration);
            entry.target.setAttribute('timer', timer.toString());
          } else {
            // console.log(
            //   'leave',
            //   entry,
            //   Date.now(),
            //   entry.target.getAttribute('start')
            // );
            clearTimeout(Number(entry.target.getAttribute('timer')));
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.5,
      }
    );
  }

  /**
   * 给元素添加监听
   * @param {Element} entry
   */
  add(entry: { el: Element }) {
    this.observer?.observe(entry.el);
  }

  /**
   * 埋点上报
   */
  track() {
    const trackData = this.exposureData.splice(0, this.maxExposureCount);
    if (trackData.length <= 0) {
      return;
    }
    console.log(`Exposure data to server: `, trackData);
    track({
      addData: JSON.stringify(trackData),
    });
    // 更新localStoragee
    this.storeIntoLocalStorage(JSON.stringify(this.exposureData));
  }

  /**
   * 存储到localstorage, 防止在设定上报时间内用户退出
   * @param { string } data
   */
  storeIntoLocalStorage(data: string) {
    window.localStorage.setItem(CACHE_KEY, data);
  }

  /**
   * 首次进入先获取localStorage中的数据，也就是用户上次退出未上报的数据上报
   * 然后每隔2秒上报一次
   */
  sendExposureData() {
    this.track();
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      this.track();
    }, REPORT_INTERVAL) as unknown as number;
  }
}
